<template>
  <div>
    <div class="header">
      <div class="container">
        <LogoDesktop class="header-logo-desktop"/>
        <LogoMobile class="header-logo-mobile"/>
        <span class="header__title">ПРОЕКТ ОЧЕНЬ<br>ПРОСТОЙ -</span>
        <span class="header-text">
          Вы раз в два дня отмечаете наличие либо отсутствие у Вас симптомов ОРВИ, мы в ответ присылаем всю статистику таких же сидящих на карантине людей рядом с Вами. <br> Тем самым мы сможем вместе собрать и анализировать динамику по появлению и исчезновению симптомов вокруг нас.
        </span>
      </div>
    </div>
    <div class="header-features-container">
      <div class="container">
        <div class="header-features">
          <div class="header-features-element">
            <div class="header-features-element__icon">
              <HeaderIcon1/>
            </div>
            <span class="header-features-element__title">Обновляйте симптомы<br>каждые 2 дня</span>
            <span class="header-features-element__text">Каждые 2 дня мы будем присылать напоминание на почту, чтобы Вы снова внесли данные по симптомам (у кого-то они могут исчезнуть, а у кого-то появиться)</span>
          </div>
          <div class="header-features-element">
            <div class="header-features-element__icon">
              <HeaderIcon2/>
            </div>
            <span class="header-features-element__title">Получайте актуальную<br>статистику вокруг Вас</span>
            <span class="header-features-element__text">Мы ежедневно будем предоставлять текущую актуальную статистику вокруг Вас</span>
          </div>
          <div class="header-features-element">
            <div class="header-features-element__icon">
              <HeaderIcon3/>
            </div>
            <span class="header-features-element__title">Сохраняем полную<br>анонимность</span>
            <span class="header-features-element__text">Указанные вами данные идут только для накопления статистики и дальнейшего оповещения вас о ее изменении</span>
          </div>
          <div class="header-features-element">
            <div class="header-features-element__icon">
              <HeaderIcon4/>
            </div>
            <span class="header-features-element__title">Делитесь с друзьями и<br>близкими </span>
            <span class="header-features-element__text">Поделитесь со своими друзьями и близкими, чтобы участников было как можно больше, тогда картина станет наиболее ясной</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoDesktop from '@/assets/svg/logo.svg';
import HeaderIcon1 from '@/assets/svg/header-icon1.svg';
import HeaderIcon2 from '@/assets/svg/header-icon2.svg';
import HeaderIcon3 from '@/assets/svg/header-icon3.svg';
import HeaderIcon4 from '@/assets/svg/header-icon4.svg';
import LogoMobile from '@/assets/svg/logo-mobile.svg';

export default {
  components: {
    LogoDesktop,
    HeaderIcon1,
    HeaderIcon2,
    HeaderIcon3,
    HeaderIcon4,
    LogoMobile
  }
}
</script>

<style lang="scss" scoped>
.header {
  padding-top: 135px;
  height: 100vh;
  background: url('/images/bg-header.jpg');
  background-size: cover;
  background-position: center;
  color: #fff;
  &-text {
    font-size: 18px;
    display: block;
    max-width: 390px;
  }
  &-logo {
    &-desktop {
      margin-bottom: 60px;
    }
    &-mobile {
      display: none;
    }
  }
  &__title {
    display: block;
    margin-bottom: 32px;
    font-size: 49px;
    font-weight: bold;
  }
  &-features {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &-container {
      background-color: #f2f7f9;
      padding-top: 160px;
      // margin-top: -140px;
    }
    &-element {
      height: 242px;
      box-shadow: 0 3px 8px rgba(82, 121, 146, 0.23);
      border-radius: 3px;
      padding: 20px;
      padding-top: 93px;
      width: 49%;
      text-align: center;
      margin-bottom: 93px;
      position: relative;
      background: #fff;
      &__title {
        display: block;
        text-transform: uppercase;
        font-weight: bold;
        margin-bottom: 20px;
      }
      &__text {
        display: block;
        font-size: 14px;
      }
      &__icon {
        position: absolute;
        top: -72px;
        left: 50%;
        margin-left: -72px;
        box-shadow: 0 3px 8px rgba(82, 121, 146, 0.23);
        border-radius: 50%;
        width: 145px;
        height: 145px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .header {
    padding-top: 40px;
    padding-bottom: 40px;
    text-align: center;
    height: auto;
    background: url('/images/bg-header-mobile.png');
    background-position: left;
    &-logo {
      &-desktop {
        display: none;
      }
      &-mobile {
        display: block;
        margin: 0 auto;
        margin-bottom: 30px;
      }
    }
    &__title {
      font-size: 30px;
      margin-bottom: 20px;
    }
    &__text {
      font-size: 15px;
    }
    &-features {
      padding-top: 80px;
      padding-bottom: 0px;
      &-container {
        padding-top: 20px;
        padding-bottom: 20px;
      }
      &-element {
        width: 100%;
        height: auto;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
// .header {
//   position: relative;
//   &-logo {
//     &-mobile {
//       display: none;
//     }
//   }
//   &__girl {
//     position: absolute;
//     bottom: 0;
//     right: 0;
//     &.mobile {
//       display: none;
//     }
//   }
//   &-top {
//     background: url('/images/background-header.jpg');
//     background-size: cover;
//     background-position: center;
//     & .container {
//       display: flex;
//       align-items: center;
//       height: 230px;
//     }
//   }
//   &-bottom {
//     background-color: #f2f7f9;
//     &-text {
//       width: 325px;
//       font-size: 20px;
//       display: block;
//       padding: 20px 0;
//       &__hash {
//         display: block;
//         font-size: 24px;
//         color: #0096c8;
//       }
//     }
//     & .container {
//       position: relative;
//     }
//   }
// }

// @media screen and (max-width: 767px) {
//   .header {
//     &-top {
//       padding-left: 30px;
//       padding-top: 20px;
//       & .container {
//         height: 306px;
//         position: relative;
//         align-items: flex-start;
//         overflow: hidden;
//       }
//     }
//     &-bottom {
//       padding: 40px 20px;
//       text-align: center;
//       &-text {
//         width: 100%;
//         font-size: 17px;
//         &__hash {
//           font-size: 20px;
//         }
//       }
//     }
//     &__girl {
//       &.mobile {
//         display: block;
//         bottom: 0;
//         height: 306px;
//         right: -20px;
//       }
//       &.desktop {
//         display: none;
//       }
//     }
//     &-logo {
//       &-desktop {
//         display: none;
//       }
//       &-mobile {
//         margin-top: 20px;
//         display: block;
//         position: relative;
//         z-index: 1;
//       }
//     }
//   }
// }
</style>